/* eslint-disable */
import { StyleSheet } from 'react-native'
import { Fonts } from '../../Themes'

export default StyleSheet.create({
  container: {
    backgroundColor: Fonts.style.color.baseColor,

    height: 40,
    alignItems: 'center',
    justifyContent: 'center'
  },

  text: {
    color: 'white',
    fontSize: Fonts.size.regular,
    fontFamily: Fonts.style.font.bold
  }

})
